// TODO: move this directive to external dop angular library

import { Directive, ElementRef, Renderer2, OnInit, Input, HostListener, DoCheck } from '@angular/core';
import { TranslationService } from 'projects/dop-core/src/public-api';

@Directive({
    selector: '[appCustomPaginator]'
})
export class CustomPaginatorDirective implements OnInit, DoCheck {

    constructor(private renderer: Renderer2, private elementRef: ElementRef) { }

    @Input() totalRecords: string;

    ngOnInit() {
        const element = this.elementRef.nativeElement;
        const self = this;
        const perPageText = TranslationService.translate('oleiPerPageText');
        const showText = TranslationService.translate('SHOW');
        setTimeout(() => {
            const leftSpan = self.renderer.createElement('span');
            if(showText.length > 4){
                self.renderer.addClass(leftSpan, 'p-dropdown-left-span-longtext');
                self.renderer.removeClass(leftSpan, 'p-dropdown-left-span')

            }
            else{
                self.renderer.addClass(leftSpan, 'p-dropdown-left-span');
                self.renderer.removeClass(leftSpan, 'p-dropdown-left-span-longtext')
            }

            const show = self.renderer.createText(showText);
            self.renderer.appendChild(leftSpan, show);

            const rightSpan = self.renderer.createElement('span');
            self.renderer.addClass(rightSpan, 'p-dropdown-right-span');
            const perPage = self.renderer.createText(perPageText);
            self.renderer.appendChild(rightSpan, perPage);

            const dropdownContainer = element.getElementsByClassName('p-inputwrapper-filled');
            const dropdown = element.getElementsByClassName('p-dropdown');
            self.renderer.addClass(dropdown[0], 'p-dropdown-custom');
            self.renderer.addClass(dropdownContainer[0], 'flex-body');

            self.renderer.appendChild(dropdownContainer[0], leftSpan);
            self.renderer.appendChild(dropdownContainer[0], rightSpan);

            self.updateRowRangeElement();

            const paginatorInDialog = document.getElementsByClassName('p-dynamic-dialog-body')[0];
            if (paginatorInDialog) {
                paginatorInDialog.addEventListener('scroll', this.onScroll);
            }
        });
    }

    // on next/prev/last/first page button click
    @HostListener('click', ['$event.target'])
    onClick(element: { className: string }) {
        if (element.className.indexOf('.p-paginator-page.p-paginator-element') ||
            element.className.indexOf('p-dropdown-item')) {
            this.updateRowRangeElement();
        }
    }

    onScroll() {
        document.getElementsByTagName('body')[0].click();
    }

    // Range from * to *  of *
    updateRowRangeElement() {
        const element = this.elementRef.nativeElement;
        const self = this;
        setTimeout(() => {
            let rowRangeElement: HTMLCollection = element.getElementsByClassName('p-dropdown-row-range');
            let currentPageInput: HTMLCollection = element.getElementsByClassName('p-input-current-page');
            let currentPageInputContainer: HTMLCollection = element.getElementsByClassName('p-input-current-page-container');
            let totalPages: HTMLCollection = element.getElementsByClassName('p-input-total-pages');

            if (!rowRangeElement[0]) {
                rowRangeElement = self.renderer.createElement('span');
                self.renderer.addClass(rowRangeElement, 'p-dropdown-row-range');
            }

            if (!currentPageInput[0]) {
                currentPageInputContainer = self.renderer.createElement('span');
                self.renderer.addClass(currentPageInputContainer, 'p-input-current-page-container');

                const page = self.renderer.createElement('span');
                const pageText = self.renderer.createText(TranslationService.translate('vbeiPage'));
                self.renderer.appendChild(page, pageText);
                self.renderer.appendChild(currentPageInputContainer, page);

                currentPageInput = self.renderer.createElement('input');
                this.renderer.setAttribute(currentPageInput, 'type', 'number');
                self.renderer.addClass(currentPageInput, 'p-input-current-page');
                self.renderer.appendChild(currentPageInputContainer, currentPageInput);

                const divider = self.renderer.createElement('span');
                const dividerText = self.renderer.createText(' / ');
                self.renderer.appendChild(divider, dividerText);
                self.renderer.appendChild(currentPageInputContainer, divider);
            }

            const dropdownLabel = element.getElementsByClassName('p-dropdown-label');
            const rowRange = +dropdownLabel[0].innerText;
            const activePage = element.getElementsByClassName('p-highlight');
            let currentPage = 1;
            if (+activePage.length > 0) {
                currentPage = +activePage[0].innerText;
            }

            if (!totalPages[0]) {
                totalPages = self.renderer.createElement('span');
                self.renderer.addClass(totalPages, 'p-input-total-pages');
                const totalPageText = self.renderer.createText(currentPage.toString());
                self.renderer.appendChild(totalPages, totalPageText);
                self.renderer.appendChild(currentPageInputContainer, totalPages);
            } else {
                let totalPagesCount = Math.trunc(+self.totalRecords / rowRange);
                if ((+self.totalRecords / rowRange) > totalPagesCount) {
                    totalPagesCount++;
                }
                totalPages[0].innerHTML = totalPagesCount.toString();
            }

            const rowRangeText = (((rowRange * (currentPage - 1)) + 1) + ' - ' +
                ((+self.totalRecords < (rowRange * currentPage)) ? self.totalRecords :
                    (rowRange * currentPage)) + ' of ' + self.totalRecords);

            if (!rowRangeElement[0]) {
                const rowRangeContent = self.renderer.createText(rowRangeText);
                self.renderer.appendChild(rowRangeElement, rowRangeContent);
                const paginatorContainer = element.getElementsByClassName('p-paginator');
                self.renderer.appendChild(paginatorContainer[0], rowRangeElement);
            } else {
                rowRangeElement[0].innerHTML = rowRangeText;
            }

            if (!currentPageInput[0]) {
                this.renderer.setProperty(currentPageInput, 'value', currentPage);
                const paginatorPagesContainer = element.getElementsByClassName('p-paginator-pages');
                self.renderer.appendChild(paginatorPagesContainer[0], currentPageInputContainer);
            } else {
                let currentPageInput = element.getElementsByClassName('p-input-current-page');
                if(currentPageInput[0].value != ''){
                    this.renderer.setProperty(currentPageInput[0], 'value', currentPage);
                }
            }
        });
    }

    // On page number enter
    @HostListener('input') onInput() {
        const element = this.elementRef.nativeElement;
        const currentPageInput = element.getElementsByClassName('p-input-current-page');
        const dropdownLabel = element.getElementsByClassName('p-dropdown-label');
        const rowRange = +dropdownLabel[0].innerText;

        if (currentPageInput[0].value <= Math.ceil(+this.totalRecords / rowRange)) {
            const allPagesContainer = element.getElementsByClassName('p-paginator-pages');
            const allPages = allPagesContainer[0].getElementsByClassName('p-paginator-page');
            for (const page of allPages) {
                if (page.innerText === currentPageInput[0].value) {
                    page.click();
                    break;
                }
            }
        } else {
            const activePage = element.getElementsByClassName('p-highlight');
            const currentPage = +activePage[0].innerText;
            this.renderer.setProperty(currentPageInput[0], 'value', currentPage);
        }
    }

    @HostListener('focusout') onfocusut() {
        const element = this.elementRef.nativeElement;
        const currentPageInput = element.getElementsByClassName('p-input-current-page');
        if (!currentPageInput[0].value || parseInt(currentPageInput[0].value, 10) < 1) {
            const activePage = element.getElementsByClassName('p-highlight');
            if (+activePage.length > 0) {
                currentPageInput[0].value = +activePage[0].innerText;
            }
        }
    }

    ngDoCheck() {
        this.updateRowRangeElement();
    }
}
